import type { StaffFormValues } from "@/default-form-values/staff/default-staff-form-values";
import type { StaffCreate } from "@/types/staff/api-types/staff-types";

export const toStaffRequest = (value: StaffFormValues): StaffCreate => ({
  level_id: value.level_id,
  first_name: value.first_name,
  last_name: value.last_name,
  preferred_name: value.preferred_name || "",
  pronouns: value.pronouns || "",
  phone: value.phone || "",
  email: value.email,
  address: value.address || "",
  emergency_contact_name: value.emergency_contact_name || "",
  emergency_contact_phone: value.emergency_contact_phone || "",
  start_date: value.start_date!,
  end_date: value.end_date || null,
  birthday: value.birthday || null,
  hours: value.hours,
  services: value.services,
});
